import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './Partnership.css';
import summitBannerImg from '../assets/YOCILAB Webiste photos/YOCILAB Youth Summit 2026 (2).png';

const partners = [
  'GIZ', 'UNICEF', 'IFC', 'USAID', 'British Council', 'Orange Cameroun',
  'University of Buea', 'MESRS', 'MINEFOP', 'StartUp Cameroon'
];

const Partnership = () => {
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach(e => e.isIntersecting && e.target.classList.add('visible')),
      { threshold: 0.1 }
    );
    const targets = ref.current?.querySelectorAll('.fade-up');
    targets?.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="partnership" ref={ref}>
      {/* Summit Banner */}
      <div className="summit-banner">
        <div className="summit-banner__bg">
          <img src={summitBannerImg} alt="YOCILAB Youth Summit 2026" className="summit-banner__img" loading="lazy" />
          <div className="summit-banner__overlay" />
        </div>
        <div className="container">
          <div className="summit-banner__content fade-up">
            <div className="summit-banner__text">
              <span className="summit-banner__tag">
                <span className="summit-banner__tag-dot" />
                Upcoming Event
              </span>
              <h2 className="summit-banner__title">
                YOCILAB Youth Summit<br />
                <em>30th &amp; 31st October 2026</em>
              </h2>
              <p className="summit-banner__desc">
                Bamenda, Cameroon · 500+ Young People · 25+ Organizations
              </p>
            </div>
            <div className="summit-banner__ctas">
              <Link to="/youth-summit/register" className="summit-banner__btn summit-banner__btn--primary">
                Register as Delegate
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path d="M2 7H12M12 7L8 3M12 7L8 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </Link>
              <Link to="/contact" className="summit-banner__btn summit-banner__btn--outline">
                Become a Partner
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Partners Marquee */}
      <div className="partners-section">
        <div className="container">
          <div className="partners-section__header fade-up">
            <span className="section-label">PARTNERS & SUPPORTERS</span>
            <p className="partners-section__desc">Working with organizations that share our vision for African youth development</p>
          </div>
          <div className="partners-marquee-wrapper">
            <div className="partners-marquee">
              {[...partners, ...partners].map((p, i) => (
                <div key={i} className="partner-chip">{p}</div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partnership;
